import "@fontsource/baskervville";
import { graphql, useStaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React from "react";
import "../../node_modules/slick-carousel/slick/slick-theme.css";
import "../../node_modules/slick-carousel/slick/slick.css";
import "../assets/css/main.css";
import Footer from "./navs/footer";
import Header from "./navs/header";
import Seo from "./seo";


const Layout = ({ title, description, children, seo, showHero = false, containered = true, heroImage, productAdded }) => {

  // GTM : ne charger le conteneur QU'UNE SEULE FOIS par chargement de page.
  // Ce bloc s'exécute pendant le rendu de Layout ; sans garde il était rejoué à
  // chaque re-render (changement d'état d'une page produit) et à chaque
  // navigation client-side, injectant un gtm.js de plus à chaque fois — donc des
  // page_views et des conversions dupliqués. Le drapeau ci-dessous conserve le
  // timing d'origine (premier rendu) sans jamais réinjecter le conteneur.
  // Les navigations SPA restent tracées par `gatsbyRouteChange`, poussé dans le
  // dataLayer par `gatsby-browser.js` (onRouteUpdate) — inchangé.
  if (typeof window !== 'undefined' && window.document && !window.__gtmLoaded) {
    window.__gtmLoaded = true;

    (function (w, d, s, l, i) {
      w[l] = w[l] || []; w[l].push({
        'gtm.start':
          new Date().getTime(), event: 'gtm.js'
      }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
    })(window, document, 'script', 'dataLayer', 'GTM-NKRVWW6');

    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', "https://www.googletagmanager.com/ns.html?id=GTM-NKRVWW6")
    iframe.setAttribute('width', 0)
    iframe.setAttribute('height', 0)
    iframe.setAttribute('style', "display:none;visibility:hidden")
    const body = document.body;
    body.insertBefore(iframe, body.children[0]);
  }

  if (false && typeof window !== 'undefined' && window.document && !window.axeptioSettings) {
    window.axeptioSettings = {
      clientId: "61c04a0fc4adc8428cecaea6",
      cookiesVersion: "tallerdeltotebag.es-base",
    };

    (function (d, s) {
      var t = d.getElementsByTagName(s)[0], e = d.createElement(s);
      e.async = true; e.src = "//static.axept.io/sdk.js";
      t.parentNode.insertBefore(e, t);

      void 0 === window._axcb && (window._axcb = []);
      window._axcb.push(function (axeptio) {
        axeptio.on("cookies:complete", function (choices) {


        })
      })
    })(document, "script");


  }

  const data = useStaticQuery(graphql`
    query {
      strapiHomepage {
        seo {
          metaTitle
          metaDescription
          shareImage {
            localFile {
              publicURL
            }
          }
        }
      }
    }
  `);

  return (
    <>
      {/* do not remove - use for ab testing */}
      <div id="branch" version={process.env.BRANCH} />
      <Seo seo={{ ...data.strapiHomepage.seo, ...seo }} />

      {/* PROMO : bandeau retiré (offre -15 % expirée le 31 juillet).
          Les styles `.bandeau-promo` / `.bandeau-track` restent dans
          `src/assets/css/main.css` pour une réactivation rapide. */}
      <Header
        title={title}
        description={description}
        productAdded={productAdded}
        showBanner={showHero}
        heroImage={heroImage}
      ></Header>
      <main className={`relative ${containered ? "container" : ""}`}>
        {children}
      </main>
      <Footer />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
